import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import {
  FiChevronRight,
  FiChevronDown,
  FiPlus,
  FiBox,
  FiPhone,
  FiUsers,
  FiClipboard,
  FiSettings,
  FiHome,
  FiBarChart2,
  FiAlertTriangle,
  FiLogOut
} from "react-icons/fi";

export default function MenuLayout({ children }) {
  const location = useLocation();
  const [openAgregar, setOpenAgregar] = useState(false);

  const isHome = location.pathname === "/";

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        margin: 0,
        padding: 0,
      }}
    >
      {/* SIDEBAR */}
      <aside
        style={{
          width: "240px",
          background: "#232f3e",
          color: "#f2f2f2",
          paddingTop: "14px",
          display: "flex",
          flexDirection: "column",
          borderRight: "1px solid #1b2733",
          userSelect: "none",
        }}
      >
        {/* TÍTULO */}
        <div style={{ padding: "0 20px", marginBottom: 20 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: "700",
              lineHeight: "20px",
              color: "#ffffff",
            }}
          >
            SISTEMA DE <br />
            INVENTARIO
          </h2>
        </div>

        {/* INICIO */}
        <AwsItem
          icon={<FiHome size={17} />}
          to="/"
          text="Inicio"
          active={location.pathname === "/"}
        />

        {/* DASHBOARD */}
        <AwsItem
          icon={<FiBarChart2 size={17} />}
          to="/dashboard"
          text="Dashboard"
          active={location.pathname.includes("/dashboard")}
        />

        {/* AGREGAR */}
        <div>
          <div
            onClick={() => setOpenAgregar(!openAgregar)}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              color: "#ffffff",
              fontSize: "15px",
              background: openAgregar ? "#1f2a36" : "transparent",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <FiPlus size={17} />
              Agregar
            </div>

            {openAgregar ? <FiChevronDown size={16} /> : <FiChevronRight size={16} />}
          </div>

          {openAgregar && (
            <div
              style={{
                background: "#1f2a36",
                paddingLeft: 55,
                paddingTop: 5,
                paddingBottom: 5,
              }}
            >
              <AwsSubItem to="/agregar" text="Crear Equipo" />
              <AwsSubItem to="/contratos/agregar" text="Crear Contrato" />
            </div>
          )}
        </div>

        {/* MENÚ PRINCIPAL */}
        <AwsItem
          icon={<FiClipboard size={17} />}
          to="/inventario"
          text="Inventario de Equipos"
          active={location.pathname.includes("/inventario")}
        />

        <AwsItem
          icon={<FiPhone size={17} />}
          to="/contratos"
          text="Contratos Telefónicos"
          active={location.pathname.includes("/contratos")}
        />

        <AwsItem
          icon={<FiUsers size={17} />}
          to="/usuarios"
          text="Usuarios"
          active={location.pathname.includes("/usuarios")}
        />

        <AwsItem
          icon={<FiBox size={17} />}
          to="/reportes"
          text="Reportes"
          active={location.pathname.includes("/reportes")}
        />

        {/* 🔥 INCIDENCIAS */}
        <AwsItem
          icon={<FiAlertTriangle size={17} />}
          to="/incidencias/crear"
          text="Reportar Incidencia"
          active={location.pathname.includes("/incidencias/crear")}
        />

        <AwsItem
          icon={<FiClipboard size={17} />}
          to="/incidencias"
          text="Ver Incidencias"
          active={location.pathname === "/incidencias"}
        />

        {/* ⚙️ CONFIGURACIÓN — CORREGIDO */}
        <AwsItem
          icon={<FiSettings size={17} />}
          to="/configuracion"
          text="Configuración"
          active={location.pathname.includes("/configuracion")}
        />

        {/* 🔻 BOTÓN CERRAR SESIÓN (FIJO ABAJO) */}
        <div style={{ marginTop: "auto", padding: "20px" }}>
          <button
            onClick={() => (window.location.href = "/logout")}
            style={{
              width: "100%",
              padding: "10px 15px",
              background: "#dc2626",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              fontWeight: "600",
            }}
          >
            <FiLogOut size={18} />
            Cerrar sesión
          </button>
        </div>
      </aside>

      {/* CONTENIDO PRINCIPAL */}
      <main
        style={{
          flex: 1,
          width: "100%",
          height: "100vh",
          overflowY: isHome ? "hidden" : "auto",
          overflowX: "hidden",
          padding: isHome ? "0px" : "30px",
          background: isHome ? "transparent" : "#f8fafc",
        }}
      >
        {children}
      </main>
    </div>
  );
}

/* ========================== */
/* COMPONENTES DEL MENÚ */
/* ========================== */

function AwsItem({ icon, text, to, active }) {
  return (
    <Link
      to={to}
      style={{
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        gap: 12,
        textDecoration: "none",
        color: active ? "#ffffff" : "#d1d5db",
        background: active ? "#1f2a36" : "transparent",
        fontSize: "15px",
        borderLeft: active ? "3px solid #00a1ff" : "3px solid transparent",
        transition: "0.15s",
      }}
    >
      {icon}
      {text}
    </Link>
  );
}

function AwsSubItem({ to, text }) {
  return (
    <Link
      to={to}
      style={{
        display: "block",
        padding: "7px 0",
        fontSize: "14px",
        textDecoration: "none",
        color: "#cbd5e1",
      }}
    >
      {text}
    </Link>
  );
}
